/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleChartData = {
    properties: {
        schedule: {
    type: 'number',
    isRequired: true,
    format: 'double',
},
        transferred: {
    type: 'number',
    isRequired: true,
    format: 'double',
},
    },
};